<div class="traceability">
    <h2>{{'trazabilidad-etiqueta.titulo' | translate}}</h2>
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible && !showOnlyTheReport">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div class="entry-single">
                <label>{{'trazabilidad-etiqueta.filters.codigoSNC' | translate}} *</label>
                <input type="text" formControlName="codigoSNC">
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <!-- <section class="export-buttons">
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section> -->
    <section *ngIf="infoList" class="traceability-report">
        <!-- Bloque fijo -->
        <figure class="logo">
            <img src="assets/img/logo_marca_horizontal02.png" alt="Gesvatec">
        </figure>
        <div class="title-group">
            <h3>{{'trazabilidad-etiqueta.informe.titulo' | translate}}</h3>
            <p>{{'trazabilidad-etiqueta.informe.codigoTrazabilidad' | translate}}: {{codigoSNC}}</p>
        </div>
        <app-stepper [steps]="steps" [iconsClassName]="icons" [allActive]="true" [heightToAdd]="blockchainInfoHeight" [sectionPosition]="parentPosition" [accordionAction]="blockchainAction">
            <!-- Proceso de cultivo -->
            <div data-step="1">
                <ng-container *ngFor="let campanya of infoList.detalleCampanyas; let i = index">
                    <!-- Campos -->
                    <div class="data-regular" *ngFor="let cultivo of campanya.detalleCultivos; let childI = index">
                        <div class="data-group">
                            <p>{{'trazabilidad-etiqueta.informe.cultivo.codigo' | translate}}</p>
                            <p>{{cultivo.codigoGsv}}</p>
                        </div>
                        <div class="data-group">
                            <p>{{'trazabilidad-etiqueta.informe.cultivo.producto' | translate}}</p>
                            <p>{{cultivo.desProducto}}</p>
                        </div>
                        <div class="data-group">
                            <p class="bold">{{'trazabilidad-etiqueta.informe.cultivo.denominacion' | translate}}</p>
                            <p>{{campanya.desDenominacionCampanya}}</p>
                        </div>
                        <div class="data-group">
                            <p>{{'global.finca' | translate}}</p>
                            <p>{{cultivo.desFinca}}</p>
                        </div>
                        <div class="data-group" *ngIf="this.role === 'Administrador' || this.claims.includes('D_TRZ_SuperficieVisible')">
                            <p>{{'trazabilidad-etiqueta.informe.cultivo.superficie' | translate}}</p>
                            <p>{{cultivo.superficie | number : '1.2-2': defaultLanguage}} ha</p>
                        </div>
                        <div class="data-group" *ngIf="this.role === 'Administrador' || this.claims.includes('D_TRZ_NPlantasVisible')">
                            <p>{{'trazabilidad-etiqueta.informe.cultivo.plantas' | translate}}</p>
                            <p>{{cultivo.nPlantas | number : '1.0-0': defaultLanguage}}</p>
                        </div>
                        <div class="data-group" *ngIf="this.role === 'Administrador' || this.claims.includes('D_TRZ_AforoVisible')">
                            <p>{{'trazabilidad-etiqueta.informe.cultivo.aforo' | translate}}</p>
                            <p>{{cultivo.aforo | number : '1.0-0': defaultLanguage}} Kg</p>
                        </div>
                        <div class="data-group" *ngIf="this.role === 'Administrador' || this.claims.includes('D_TRZ_ProductorVisible')">
                            <p>{{'trazabilidad-etiqueta.informe.cultivo.productor' | translate}}</p>
                            <p>{{cultivo.desProductor}}</p>
                        </div>
                        <div class="data-group">
                            <p>{{'global.municipio' | translate}}</p>
                            <p>{{cultivo.desMunicipio}}</p>
                        </div>
                        <div class="data-group">
                            <p>{{'global.provincia' | translate}}</p>
                            <p>{{cultivo.desProvincia}}</p>
                        </div>
                        <div class="data-group">
                            <p>{{'global.pais' | translate}}</p>
                            <p>{{cultivo.desPaisDefecto}}</p>
                        </div>
                        <!-- TO-DO: Cuando el mapa esté listo, eliminar estos 2 últimos divs y descomentar el ng-container de debajo !!! -->
                        <div class="data-group" *ngIf="cultivo && cultivo.poligonoCatastral">
                            <p>{{'trazabilidad-etiqueta.informe.cultivo.poligonoCatastral' | translate}}</p>
                            <p>{{cultivo.poligonoCatastral}}</p>
                        </div>
                        <div class="data-group" *ngIf="cultivo && cultivo.parcelaCatastral">
                            <p>{{'trazabilidad-etiqueta.informe.cultivo.parcelaCatastral' | translate}}</p>
                            <p>{{cultivo.parcelaCatastral}}</p>
                        </div>
                        <!-- Desplegable blockchain -->
                        <div *ngIf="cultivo.cultivoVechain?.existeRegBlockchain" class="blockchain-container collapsed" [ngClass]="'blockchain-container-cultivo' + i + (childI.toString())">
                            <div class="blockchain-title" [ngClass]="'blockchain-title-cultivo' + i + (childI.toString())" (click)="showOrHideData(0, true, 'cultivo', i, childI)">
                                <i class="fas fa-circle-nodes"></i>
                                <h4>{{'global.blockchain.verRastreo' | translate}}</h4>
                                <i class="fas fa-angle-down blockchain-arrow" [ngClass]="'blockchain-arrow-cultivo' + i + (childI.toString())"></i>
                            </div>
                            <div class="blockchain-content" [ngClass]="'blockchain-content-cultivo' + i + (childI.toString())">
                                <div class="data-blockchain link">
                                    <p>{{'global.blockchain.informacion.blockchain' | translate}}</p>
                                    <span>
                                        {{cultivo.cultivoVechain?.blockchain}}
                                        (<a href="{{cultivo.cultivoVechain?.txIdExplore}}" target="_blank">{{'global.blockchain.informacion.enlace' | translate}}</a>)
                                    </span>
                                </div>
                                <div class="data-blockchain">
                                    <p>{{'global.blockchain.informacion.fechaRegistro' | translate}}</p>
                                    <p>{{cultivo.cultivoVechain?.fechaRegistro | date:'dd/MM/YYYY HH:mm:SS'}}</p>
                                </div>
                                <div class="data-blockchain">
                                    <p>{{'global.blockchain.informacion.hash' | translate}}</p>
                                    <p>{{cultivo.cultivoVechain?.hash}}</p>
                                </div>
                                <div class="data-blockchain">
                                    <p>{{'global.blockchain.informacion.idCripto' | translate}}</p>
                                    <p>{{cultivo.cultivoVechain?.txId}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Importante: no borrar este bloque. Mapa. TO-DO: añadir !!!
                    <ng-container *ngFor="let cultivo of campanya.detalleCultivos">
                        <div class="data-map" *ngIf="(cultivo && cultivo.poligonoCatastral) || (cultivo && cultivo.parcelaCatastral)">
                            <div>
                                <p *ngIf="cultivo && cultivo.poligonoCatastral">{{'trazabilidad-etiqueta.informe.cultivo.poligonoCatastral' | translate}} <span>{{cultivo.poligonoCatastral}}</span></p>
                                <p *ngIf="cultivo && cultivo.parcelaCatastral">{{'trazabilidad-etiqueta.informe.cultivo.parcelaCatastral' | translate}} <span>{{cultivo.parcelaCatastral}}</span></p>
                            </div>
                        </div>
                    </ng-container> -->
                </ng-container>
            </div>
            <!-- Proceso de designación -->
            <div data-step="2">
                <div class="data-group">
                    <p>{{'trazabilidad-etiqueta.informe.designacion.fecha' | translate}}</p>
                    <p>{{infoList.fechaDesignacion | date:'dd/MM/yyyy'}}</p>
                </div>
                <div class="data-group">
                    <p>{{'trazabilidad-etiqueta.informe.designacion.etiquetador' | translate}}</p>
                    <p>{{infoList.desEtiquetadorDsg}}</p>
                </div>
                <div class="data-group">
                    <p>{{'trazabilidad-etiqueta.informe.designacion.designados' | translate}}</p>
                    <p>{{infoList.designadoKg | number : '1.0-0': defaultLanguage}} Kg</p>
                </div>
                <!-- Desplegable blockchain -->
                <ng-container *ngFor="let campanya of infoList.detalleCampanyas; let i = index">
                    <ng-container *ngFor="let cultivo of campanya.detalleCultivos; let childI = index">
                        <div *ngIf="cultivo.designacionVechain?.existeRegBlockchain" class="blockchain-container collapsed" [ngClass]="'blockchain-container-designacion' + i + (childI.toString())">
                            <div class="blockchain-title" [ngClass]="'blockchain-title-designacion' + i + (childI.toString())" (click)="showOrHideData(1, true, 'designacion', i, childI)">
                                <i class="fas fa-circle-nodes"></i>
                                <h4>{{'global.blockchain.verRastreo' | translate}}</h4>
                                <i class="fas fa-angle-down blockchain-arrow" [ngClass]="'blockchain-arrow-designacion' + i + (childI.toString())"></i>
                            </div>
                            <div class="blockchain-content" [ngClass]="'blockchain-content-designacion' + i + (childI.toString())">
                                <div class="data-blockchain link">
                                    <p>{{'global.blockchain.informacion.blockchain' | translate}}</p>
                                    <span>
                                        {{cultivo.designacionVechain?.blockchain}}
                                        (<a href="{{cultivo.designacionVechain?.txIdExplore}}" target="_blank">{{'global.blockchain.informacion.enlace' | translate}}</a>)
                                    </span>
                                </div>
                                <div class="data-blockchain">
                                    <p>{{'global.blockchain.informacion.fechaRegistro' | translate}}</p>
                                    <p>{{cultivo.designacionVechain?.fechaRegistro | date:'dd/MM/YYYY HH:mm:SS'}}</p>
                                </div>
                                <div class="data-blockchain">
                                    <p>{{'global.blockchain.informacion.hash' | translate}}</p>
                                    <p>{{cultivo.designacionVechain?.hash}}</p>
                                </div>
                                <div class="data-blockchain">
                                    <p>{{'global.blockchain.informacion.idCripto' | translate}}</p>
                                    <p>{{cultivo.designacionVechain?.txId}}</p>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            <!-- Proceso de confección -->
            <div data-step="3">
                <div class="data-group">
                    <p>{{'trazabilidad-etiqueta.informe.confeccion.exportador' | translate}}</p>
                    <p>{{infoList.desEtiquetador}}</p>
                </div>
                <div class="data-group">
                    <p>{{'global.almacen' | translate}}</p>
                    <p>{{infoList.desAlmacen}}</p>
                </div>
                <div class="data-group">
                    <p>{{'trazabilidad-etiqueta.informe.confeccion.direccion' | translate}}</p>
                    <p>{{infoList.direccionAlmacen}}</p>
                </div>
                <div class="data-group">
                    <p>{{'global.municipio' | translate}}</p>
                    <p>{{infoList.desMunicipioAlmacen}}</p>
                </div>
                <div class="data-group">
                    <p>{{'global.provincia' | translate}}</p>
                    <p>{{infoList.desProvinciaAlmacen}}</p>
                </div>
                <div class="data-group">
                    <p>{{'global.pais' | translate}}</p>
                    <p>{{infoList.desPaisDefectoAlmacen}}</p>
                </div>
                <div class="data-group">
                    <p>{{'trazabilidad-etiqueta.informe.confeccion.confeccion' | translate}}</p>
                    <p>{{infoList.desConfeccion}}</p>
                </div>
                <div class="data-group">
                    <p>{{'trazabilidad-etiqueta.informe.confeccion.cajas' | translate}}</p>
                    <p>{{infoList.numCajas}}</p>
                </div>
                <div class="data-group">
                    <p>{{'trazabilidad-etiqueta.informe.confeccion.envases' | translate}}</p>
                    <p>{{infoList.sumEnvases}}</p>
                </div>
                <!-- Desplegable blockchain -->
                <ng-container *ngFor="let campanya of infoList.detalleCampanyas; let i = index">
                    <ng-container *ngFor="let cultivo of campanya.detalleCultivos; let childI = index">
                        <div *ngIf="cultivo.consumoVechain?.existeRegBlockchain" class="blockchain-container collapsed" [ngClass]="'blockchain-container-confeccion' + i + (childI.toString())">
                            <div class="blockchain-title" [ngClass]="'blockchain-title-confeccion' + i + (childI.toString())" (click)="showOrHideData(2, true, 'confeccion', i, childI)">
                                <i class="fas fa-circle-nodes"></i>
                                <h4>{{'global.blockchain.verRastreo' | translate}}</h4>
                                <i class="fas fa-angle-down blockchain-arrow" [ngClass]="'blockchain-arrow-confeccion' + i + (childI.toString())"></i>
                            </div>
                            <div class="blockchain-content" [ngClass]="'blockchain-content-confeccion' + i + (childI.toString())">
                                <div class="data-blockchain link">
                                    <p>{{'global.blockchain.informacion.blockchain' | translate}}</p>
                                    <span>
                                        {{cultivo.consumoVechain?.blockchain}}
                                        (<a href="{{cultivo.consumoVechain?.txIdExplore}}" target="_blank">{{'global.blockchain.informacion.enlace' | translate}}</a>)
                                    </span>
                                </div>
                                <div class="data-blockchain">
                                    <p>{{'global.blockchain.informacion.fechaRegistro' | translate}}</p>
                                    <p>{{cultivo.consumoVechain?.fechaRegistro | date:'dd/MM/YYYY HH:mm:SS'}}</p>
                                </div>
                                <div class="data-blockchain">
                                    <p>{{'global.blockchain.informacion.hash' | translate}}</p>
                                    <p>{{cultivo.consumoVechain?.hash}}</p>
                                </div>
                                <div class="data-blockchain">
                                    <p>{{'global.blockchain.informacion.idCripto' | translate}}</p>
                                    <p>{{cultivo.consumoVechain?.txId}}</p>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </app-stepper>
    </section>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes"
        (closed)="showError=$event;showWarning=$event">
    </app-toast>
</div>
